import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { doesUserConsentToRetargeting } from '../user/consents/consent-reducer';
import { useLocation } from 'react-router';
import { hasDocument, hasWindow } from '../utils';

export const useSnapchatPixel = () => {
    const pixelTrackingId = useSelector((state) => state.snapchatPixelTrackingId);
    const consentedToRetargeting = useSelector((state) => doesUserConsentToRetargeting(state));

    const { pathname } = useLocation();
    const isDocumentAvailable = hasDocument();
    const snaptrExists = hasWindow() ? !!window?.snaptr : false;

    useEffect(() => {
        if (!isDocumentAvailable || !consentedToRetargeting) {
            return;
        }
        (function (e, t, n) {
            if (e.snaptr) {
                return;
            }
            const a = (e.snaptr = function () {
                a.handleRequest ? a.handleRequest.apply(a, arguments) : a.queue.push(arguments);
            });
            a.queue = [];
            const s = 'script';
            const r = t.createElement(s);
            r.async = !0;
            r.src = n;
            const u = t.getElementsByTagName(s)[0];
            u.parentNode.insertBefore(r, u);
        })(window, document, 'https://sc-static.net/scevent.min.js');
    }, []);

    useEffect(() => {
        if (pixelTrackingId && consentedToRetargeting && snaptrExists) {
            window.snaptr('init', pixelTrackingId);
        }
    }, [pixelTrackingId, snaptrExists, consentedToRetargeting]);

    useEffect(() => {
        if (pixelTrackingId && consentedToRetargeting && snaptrExists) {
            window.snaptr('track', 'PAGE_VIEW');
        }
    }, [pixelTrackingId, pathname, snaptrExists, consentedToRetargeting]);
};
